import { render, staticRenderFns } from "./Nudge.vue?vue&type=template&id=ecc4034e"
import script from "./Nudge.vue?vue&type=script&lang=js"
export * from "./Nudge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ecc4034e')) {
      api.createRecord('ecc4034e', component.options)
    } else {
      api.reload('ecc4034e', component.options)
    }
    module.hot.accept("./Nudge.vue?vue&type=template&id=ecc4034e", function () {
      api.rerender('ecc4034e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/js/components-wa/messages/Nudge.vue"
export default component.exports